import { render, staticRenderFns } from "./VideoLoading.vue?vue&type=template&id=68673f50"
import script from "./VideoLoading.vue?vue&type=script&lang=js"
export * from "./VideoLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports